import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/mouse.png'
import _imports_1 from '@/assets/ab.png'


const _withScopeId = n => (_pushScopeId("data-v-87b1c094"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "about-body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "about-text" }, [
    /*#__PURE__*/_createElementVNode("h1", null, [
      /*#__PURE__*/_createTextVNode("withHalal,"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode("Everyone can scale")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " We strive to give small businesses and unbanked communities the financial tools and resources they need to succeed. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "about-box" }),
  /*#__PURE__*/_createElementVNode("div", { class: "about-mouse" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "ab",
        class: "w-100"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "about-img" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "ab",
      class: "w-100"
    })
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_about_box = _resolveComponent("about-box")!
  const _component_about_value = _resolveComponent("about-value")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, { footer: true }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_about_box),
        _createVNode(_component_about_value)
      ])
    ]),
    _: 1
  }))
}